export const FAVOURITES_AND_LISTS = 'Favourites & lists';
